<template>
  <div class="threeCapital_wrap">
    <div class="threeCapital_title">
      <h2>三资管理</h2>
    </div>
    <ul v-if="productFlag==3" class="threeCapital_item">
      <li v-if="isStudent||$_has('zledu.gxzx.zhsxappsz:kjhs')">
        <img src="../img/kjhs-logo.png" alt="" class="app_logo">
        <img src="../img/kjhs-bg.png" alt="" class="app_bg">
        <el-button @click="entrySys('kjhs')">进入系统 <i class="el-icon-right"></i> </el-button>
      </li>
      <li v-if="isStudent||$_has('zledu.gxzx.zhsxappsz:bzzx')">
        <img src="../img/bzzx-logo.png" alt="" class="app_logo">
        <img src="../img/bzzx-bg.png" alt="" class="app_bg">
        <el-button @click="entrySys('zjbz')">进入系统 <i class="el-icon-right"></i> </el-button>
      </li>
      <li v-if="isStudent||$_has('zledu.gxzx.zhsxappsz:zcgl')">
        <img src="../img/zcgl-logo.png" alt="" class="app_logo">
        <img src="../img/zcgl-bg.png" alt="" class="app_bg">
        <el-button @click="entrySys('zcgl')">进入系统 <i class="el-icon-right"></i> </el-button>
      </li>
      <li v-if="isStudent||$_has('zledu.gxzx.zhsxappsz:zygl')">
        <img src="../img/zygl-logo.png" alt="" class="app_logo">
        <img src="../img/zygl-bg.png" alt="" class="app_bg">
        <el-button @click="entrySys('zygl')">进入系统 <i class="el-icon-right"></i> </el-button>
      </li>
      <li v-if="isStudent||$_has('zledu.gxzx.zhsxappsz:dzda')">
        <img src="../img/dzda-logo.png" alt="" class="app_logo">
        <img src="../img/dzda-bg.png" alt="" class="app_bg">
        <el-button @click="entrySys('dagl')">进入系统 <i class="el-icon-right"></i> </el-button>
      </li>
      <li v-if="isStudent||$_has('zledu.gxzx.zhsxappsz:jgcx')">
        <img src="../img/jgcx-logo.png" alt="" class="app_logo">
        <img src="../img/jgcx-bg.png" alt="" class="app_bg">
        <el-button @click="entrySys('zhcx')">进入系统 <i class="el-icon-right"></i> </el-button>
      </li>
    </ul>
  </div>
</template>
<script>
import axios from 'axios'
import qs from 'qs'
import crypto from 'crypto'
import * as userApi from '../../../../api/userApi'
export default {
  data() {
    return {
      sysUserPermissionList: JSON.parse(localStorage.getItem('sysUserPermissionList'))  || [], // 权限对象
      userType:sessionStorage.getItem('userType'), //用户身份
      isStudent: false,
      productFlag: sessionStorage.getItem('productFlag'),
			sys: ''
    };
  },
  created() {
    if(this.userType==2 || this.userType==3){
      this.isStudent = true
    }else{
      this.isStudent = false
    }
  },
  methods: {
    setSha1(url){//sha1加密
      const hmac = crypto.createHmac('sha1', '123456');
      hmac.update(url);
      return hmac.digest('hex')
    },
    entrySys(sys){
      if(localStorage.getItem('Authorization')){
				userApi.isExpired(localStorage.getItem('Authorization')).then(rs=>{
          if(rs.code==0 && rs.data==0){
            if(sys=='zhcx'||sys=='zcgl'||sys=='zygl'||sys=='dagl'||sys=='kjhs'||sys=='zjbz'){
              let userType = sessionStorage.getItem('userType')
              var tmpWin = window.open()
              tmpWin.document.open();
              tmpWin.document.write("跳转中，请稍后。。。");
              tmpWin.document.close();
              let phone = sessionStorage.getItem('mobile')
              let name = sessionStorage.getItem('loginName')
              let schoolId = sessionStorage.getItem('deptId')
              let schoolName = sessionStorage.getItem('deptName')
              let time = new Date().getTime() +""
              let userId = sessionStorage.getItem('userId')

              let classId = '999998880'
              let courseId = '99999988'


              let sourceId = ""  // examType_courseId_classId_examPlan_teamId_userId_catalogType    ${实训还是课程（catalogType）}
              sourceId = `4_${courseId}_${classId}_NONE_NONE_${userId}_NONE`

              let url = 'classId='+classId+'&className=x师资培训班&courseId='+courseId+'&mobile='+phone+'&nickName='+name+'&platform='+sys+'&questionId=999998888&schoolId='+schoolId +'&schoolName='+schoolName + '&sourceId='+sourceId+'&time='+time+'&userId='+userId+'&userType='+userType
              let sha1sign = this.setSha1(url)
              let stxObj = {
                courseId: courseId,
                classId: classId,
                className: 'x师资培训班',
                mobile: phone,
                nickName: name,
                platform: sys,
                questionId: '999998888',
                schoolId: schoolId,
                schoolName: schoolName,
                templates: "001",
                time: time,
                userId: userId,
                userType: sessionStorage.getItem('userType'),
                sign: sha1sign,
                sourceId: sourceId
              }
              axios.post(process.env.SZ_API,qs.stringify(stxObj)).then(res=>{
                if(res.data.result){
                  tmpWin.location = res.data.value
                  this.loading = false
                }else{
                  this.$messageError(res.data.error.message)
                  tmpWin.document.open();
                  tmpWin.document.write(res.data.error.message);
                  tmpWin.document.close();
                  this.loading = false
                }
              }).catch(err=>{
                tmpWin.document.open();
                if(err.code == '401'){
                  tmpWin.document.write("登录已过期，请重新登录");
                  tmpWin.location.href = process.env.BASE_API
                }else{
                  tmpWin.document.write("接口访问异常"+err.code);
                }
                tmpWin.document.close();
                this.loading = false
              })
            }else{
              this.loading = false
              this.$messageWarning('暂无权限，请联系管理员！')
            }
          }else{
            this.$router.push({path:'/home'})
            this.$messageError('登录已过期，请重新登录')
            localStorage.removeItem('Authorization')
            localStorage.removeItem('isbinding')
          }
        }).catch(err=>{
          console.log(err)
        })
      }else{
        this.loading = false
        this.$router.push({path:'/home'})
      }
    },
  }
}
</script>
<style lang="scss" scoped>
.threeCapital_wrap {
  .threeCapital_title {
    height: 48px;
    display: flex;
    align-items: center;
    justify-content: space-between;
    border-bottom: 1px solid #5397f7;
    h2 {
      border-left: 2px solid #5397f7;
      color: #5397f7;
      font-size: 14px;
      padding-left: 4px;
      line-height: 10px;
    }
  }
  .threeCapital_item {
    display: flex;
    flex-wrap: wrap;
    margin-bottom: 24px;
    li{
      width:278px;
      height:180px;
      background:rgba(255,255,255,1);
      box-shadow:0px 2px 8px rgba(0,0,0,0.16);
      border-radius:4px;
      position: relative;
      margin-top: 24px;
      margin-right: 40px;
      .app_logo{
        position: absolute;
        left: 24px;
        top: 27px;
        z-index: 2;
        height: 19px;
      }
      .app_bg{
        position: absolute;
        left: 0;
        top: 0;
        z-index: 1;
        width:278px;
        height:180px;
      }
      button{
        position: absolute;
        left: 40px;
        bottom: 24px;
        z-index: 2;
        width:96px;
        height:34px;
        background:rgba(255,255,255,1);
        border:1px solid rgba(83,151,247,1);
        border-radius:4px;
        padding: 0;
        color: #5397F7;
        &:hover{
          background: #5397F7;
          color: #fff;
        }
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/views/appCenter/components/threeCapital.vue